import { useState } from "react";
import { MenuDto } from "../../../dtos/menu/menuDto";
import { useMenuOpen } from "src/hooks/useMenuOpen";
import { menuIcon_First } from "../../../utils/menu/menuUtil";
import { FolderOutlined } from "@ant-design/icons";
import { FileWithLinesIcon } from "../common";

interface Props {
	data: MenuDto;
}

export const TopbarMenu = ({ data }: Props) => {

	const [expandSecondMenu, setExpandSecondMenu] = useState(false);
	const [selectedSecondMenu, setSelectedSecondMenu] = useState<MenuDto>();
	const [selectedThirdMenu, setSelectedThirdMenu] = useState<MenuDto>();
	const [selectedFourthMenu, setSelectedFourthMenu] = useState<MenuDto>();

	const { openMenuFromDto } = useMenuOpen();

	// 현재 1차 메뉴의 2차 메뉴들을 찾기 (subMenu 속성에서 가져오기)
	const secondMenus = data.subMenu ? data.subMenu.filter(menu => menu.useYn === 'Y') : [];
	

	const hoverTopbarMenuBgClass = "hover:bg-gray-400 hover:text-white ";
	const hoverTopbarMenuBorderClass = "hover:border-r-2 hover:border-blue-500";

	return <>
		<div className="relative topbar-menu-width_first h-full hover:bg-blue"
		onMouseEnter={() => setExpandSecondMenu(true)}
		onMouseLeave={() => setExpandSecondMenu(false)}>
			<p className={`w-full h-full font-semibold ${expandSecondMenu && "text-black"} text-white flex justify-start items-center pl-[15px] truncate`}>
				{menuIcon_First(data)}
				{data.menuNm}
			</p>
			{/* 왼쪽으로 이동시킬 시 left-[-175px] 추가 */}
			{expandSecondMenu && <div className={`topbar-menu-width_second absolute flex flex-col top-[40px] z-10 shadow-xl border-r border-gray-200 cursor-pointer 
				
				`}>
				{/* 2차 메뉴가 없는 경우 */}
				{secondMenus.length === 0 && 
					<div className="w-full h-[40px] relative"
						onMouseEnter={() => setSelectedSecondMenu(undefined)}
						onMouseLeave={() => setSelectedSecondMenu(undefined)}
					>
						<div className="w-full h-full relative">
							<p className={`h-full ${hoverTopbarMenuBgClass + hoverTopbarMenuBorderClass} bg-white flex justify-start items-center pl-[15px]`}>
								비어있음	
							</p>
						</div>
					</div>
				}
				{/* 2차 메뉴가 있는 경우 */}
				{secondMenus.map((secondMenu) => <div key={secondMenu.menuCd} className="w-full h-[40px]"
					onMouseEnter={() => setSelectedSecondMenu(secondMenu)}
					onMouseLeave={() => setSelectedSecondMenu(undefined)}
				>
					<div className="w-full h-full relative">
						<p className={`h-full ${hoverTopbarMenuBgClass + hoverTopbarMenuBorderClass} bg-white flex justify-start items-center pl-[15px]`}>
							<FolderOutlined style={{ color: '#1D4ED8', fontSize: '20px', marginRight: '4px' , paddingLeft: '10px' }} />
							{secondMenu.menuNm}
						</p>
						{selectedSecondMenu && selectedSecondMenu.menuCd === secondMenu.menuCd && <div className="w-full absolute left-[100%] top-0 flex flex-col z-20  shadow-xl">
							{(secondMenu.subMenu || []).filter(menu => menu.useYn === 'Y').map((thirdMenu) => {
								const clickable = thirdMenu.devSts === 30 || thirdMenu.devSts === 40 || thirdMenu.devSts ===  50;
								const hasSubMenu = thirdMenu.subMenu && thirdMenu.subMenu.length > 0;
								const isStatus99 = thirdMenu.devSts === 99;

								return (
									<div key={thirdMenu.menuCd} className="topbar-menu-width_third h-[40px] relative"
										onMouseEnter={() => hasSubMenu ? setSelectedThirdMenu(thirdMenu) : undefined}
										onMouseLeave={() => hasSubMenu ? setSelectedThirdMenu(undefined) : undefined}
										onClick={!hasSubMenu && clickable ? () => openMenuFromDto(thirdMenu) : undefined}>
										<p className={`h-full ${clickable ? hoverTopbarMenuBgClass : isStatus99 ? `text-black ${hoverTopbarMenuBgClass + hoverTopbarMenuBorderClass}` : 'text-gray-500'} bg-white flex justify-start items-center pl-[15px]`}>

										{hasSubMenu ? (
												<FolderOutlined style={{ color: '#1D4ED8', fontSize: '20px', marginRight: '4px' }} />
											) : (
												<FileWithLinesIcon className="min-w-[35px] w-[35px] h-[20px]" style={{ color: '#1D4ED8' }} />
											)}

											{thirdMenu.menuNm} 
											{hasSubMenu && <span className="ml-1"></span>}
											{/* <br /> {thirdMenu.devSts}% */}
										</p>
										
										{hasSubMenu && selectedThirdMenu && selectedThirdMenu.menuCd === thirdMenu.menuCd && (
											<div className="topbar-menu-width_fourth absolute left-[100%] top-0 flex flex-col z-30 shadow-xl">
												{(thirdMenu.subMenu || []).filter(menu => menu.useYn === 'Y').map((fourthMenu) => {
													const fourthClickable = fourthMenu.devSts === 30 || fourthMenu.devSts === 40 || fourthMenu.devSts === 50;
													const fourthHasSubMenu = fourthMenu.subMenu && fourthMenu.subMenu.length > 0;
													const fourthIsStatus99 = fourthMenu.devSts === 99;
													
													return <div key={fourthMenu.menuCd} className="w-full h-[40px] relative"
														onMouseEnter={() => fourthHasSubMenu ? setSelectedFourthMenu(fourthMenu) : undefined}
														onMouseLeave={() => fourthHasSubMenu ? setSelectedFourthMenu(undefined) : undefined}
														onClick={!fourthHasSubMenu && fourthClickable ? () => openMenuFromDto(fourthMenu) : undefined}>
														<p className={`h-full ${fourthClickable ? hoverTopbarMenuBgClass : fourthIsStatus99 ? `text-black ${hoverTopbarMenuBgClass + hoverTopbarMenuBorderClass}` : 'text-gray-500'} bg-white flex justify-start items-center pl-[15px]`}>
															{fourthHasSubMenu ? (
																<FolderOutlined style={{ color: '#1D4ED8', fontSize: '20px', marginRight: '4px' }} />
															) : (
																<FileWithLinesIcon className="min-w-[35px] w-[35px] h-[20px]" style={{ color: '#1D4ED8' }} />
															)}
															{fourthMenu.menuNm}
															{fourthHasSubMenu && <span className="ml-1"></span>}
														</p>
														
														{fourthHasSubMenu && selectedFourthMenu && selectedFourthMenu.menuCd === fourthMenu.menuCd && (
															<div className="topbar-menu-width_fifth absolute left-[100%] top-0 flex flex-col z-40 shadow-xl">
																{(fourthMenu.subMenu || []).filter(menu => menu.useYn === 'Y').map((fifthMenu) => {
																	const fifthClickable = fifthMenu.devSts === 30 || fifthMenu.devSts === 40 || fifthMenu.devSts === 50;
																	const fifthIsStatus99 = fifthMenu.devSts === 99;
																	
																	return <div key={fifthMenu.menuCd} className="w-full h-[40px]"
																		onClick={fifthClickable ? () => openMenuFromDto(fifthMenu) : undefined}>
																		<p className={`h-full ${fifthClickable ? hoverTopbarMenuBgClass : fifthIsStatus99 ? `text-black ${hoverTopbarMenuBgClass + hoverTopbarMenuBorderClass}` : 'text-gray-500'} bg-white flex justify-start items-center pl-[15px]`}>
																			<FileWithLinesIcon className="min-w-[35px] w-[35px] h-[20px]" style={{ color: '#1D4ED8' }} />
																			{fifthMenu.menuNm}
																		</p>
																	</div>
																})}
															</div>
														)}
													</div>
												})}
											</div>
										)}
									</div>
								)
							})}
						</div>}
					</div>
				</div>)}
			</div>}
		</div>
	</>
}